import styled, { css } from "styled-components";

const CheckboxContainer = styled.div`
    position: relative;
`
export default CheckboxContainer;